<script setup>
import { reactive, readonly } from "vue";
import { router } from "@inertiajs/vue2";
import TipTap from "../Editor/TipTap.vue";

// Props

const props = defineProps({
    crmClient: {
        type: Object,
        required: true,
    },
    errors: {
        type: Object,
        default: () => {},
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

// Emits

const emit = defineEmits(["toast"]);

// Reactive State

const form = reactive({ crm_note: props.crmClient.crm_note });

// Methods

function submit() {
    router.put(
        route(
            "guestSession.notes",
            props.crmClient.lead?.id ?? props.crmClient.id // allows both users and leads to be updated
        ),
        form,
        {
            preserveState: true,
            preserveScroll: true,
            onSuccess: (page) => {
                emit("toast", page.props.successMessage);
            },
        }
    );
}
</script>

<template>
    <v-form @prevent="submit">
        <TipTap
            v-model="form.crm_note"
            :characterLimit="2048"
            icon="save"
            valid
            :disabled="props.disabled"
            @submit="submit"
        />
        <v-input
            :error-messages="errors.crm_note"
            hide-details="auto"
            class="px-6"
        />
    </v-form>
</template>
